


















































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import { ItoggleEvent } from '@/components/Checkbox/CheckBoxTypes';
import { insideProviderIframe } from '@/utils/providerIframe';

import eventBus from '@/utils/eventBus';
import CloseModalIcon from '@/components/icons/CloseModal.vue';
import Picture from '@/components/atoms/Picture/Picture.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import ToggleBox from '@/componentsV2/molecules/ToggleBox/ToggleBox.vue';
import Checkbox from '@/components/Checkbox/Checkbox.vue';

import CampaignService from '@/api/CampaignService';
import BusinessPayoutService from '@/api/BusinessPayoutService';

import {
  openCentralizedPopupWindow,
  closeOnWindowPopupUrlMatches
} from '@/utils/windowPopup';
import { BusinessPayoutMethod } from '@/api/interfaces/business-payout-withdraw.interface';
import { BusinessPayoutWithdrawDetails } from '@/api/interfaces/business-payout-withdraw-details.interface';
import segmentIo from '@/utils/segment.io';

@Component({
  components: {
    CloseModalIcon,
    Picture,
    FilledButton,
    ToggleBox,
    Checkbox
  }
})
export default class WithdrawSellCoins extends Vue {
  @Prop() onConfirm!: any;
  @Prop() data!: BusinessPayoutWithdrawDetails;
  campaignService = new CampaignService();
  businessPayoutService = new BusinessPayoutService();

  loading: boolean = false;
  instantPayoutStatus: boolean = false;
  withdrawSucceeded: boolean = false;
  withdrawDetails: BusinessPayoutWithdrawDetails | null = null;

  changeMethodLoading: boolean = false;
  withdrawLoading: boolean = false;

  handleClose() {
    eventBus.$emit('closeModal');
  }

  async handleChangeMethod() {
    this.changeMethodLoading = true;

    const { data } = await this.campaignService.checkBusiness();
    const { payment } = data;

    this.changeMethodLoading = false;

    if (insideProviderIframe()) {
      const newWindow = (openCentralizedPopupWindow(
        payment.url,
        'ConnectOauth'
      ) as unknown) as Window;

      closeOnWindowPopupUrlMatches(
        newWindow,
        process.env.VUE_APP_DASHBOARD_URL || 'twism'
      );
    } else {
      window.open(`${payment.url}#settings`, '_blank');
    }
  }

  async handleWithdraw() {
    if (!this.withdrawDetails) {
      return;
    }

    this.withdrawLoading = true;

    try {
      const { data } = await this.businessPayoutService.withdraw({
        method: this.instantPayoutStatus
          ? BusinessPayoutMethod.INSTANT
          : BusinessPayoutMethod.STANDARD,
        displayAmount: this.withdrawDetails.grossAmount,
        netAmount: this.withdrawDetails.netAmount
      });

      if (data) {
        this.withdrawSucceeded = true;

        return this.onConfirm({
          instantPayoutStatus: this.instantPayoutStatus
        });
      }

      // Update Withdraw  Details
      await this.getWithdrawDetails();
    } finally {
      this.withdrawLoading = false;
    }
  }

  get tPrefix() {
    return 'sellCoins.modals';
  }

  onToggleInstantPayout(event: ItoggleEvent) {
    this.instantPayoutStatus = event.state;
    this.getWithdrawDetails();
  }

  async getWithdrawDetails() {
    try {
      this.loading = true;
      const { data } = await this.businessPayoutService.getWithdrawDetails({
        method: this.instantPayoutStatus
          ? BusinessPayoutMethod.INSTANT
          : BusinessPayoutMethod.STANDARD
      });

      this.loading = false;

      if (!data) {
        return this.handleClose();
      }

      this.withdrawDetails = data;
    } catch (error) {
      this.handleClose();
    }
  }

  mounted() {
    segmentIo.modal('Sell Coins/Withdraw');
    this.withdrawDetails = this.data;
  }
}
